module.exports = __webpack_public_path__ + "Body_feathers_DiffuseColor.bbbb9f4.basis";